'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { RadioGroup } from '@headlessui/react';
import { useState } from 'react';
import { Button } from '@src/components/Button/Button';
import { useLoadings } from '@src/hooks/useLoadings';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import type { SKUSelectorProps } from './SKUSelectorProps';
import { SKUSelectorRadio } from './SKUSelectorRadio';
export function SKUSelector(props) {
  const $ = _c(34);
  const firstOption = props.options?.[0];
  const firstDropdownOption = firstOption?.dropdownOptions?.[0];
  const [selectedSku, setSelectedSku] = useState(firstDropdownOption?.sku ?? firstOption?.sku ?? "");
  const isLoading = useLoadings().loadings.isAddingLineItems ?? false;
  const breakpoints = useBreakpoints();
  const isMobile = breakpoints.isMobile || breakpoints.isTablet;
  let t0;
  if ($[0] !== isLoading) {
    t0 = sku => sku && !isLoading && setSelectedSku(sku);
    $[0] = isLoading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== isLoading || $[3] !== props.builderBlock || $[4] !== props.options || $[5] !== props.previewAllItems || $[6] !== selectedSku) {
    let t2;
    if ($[8] !== isLoading || $[9] !== props.builderBlock || $[10] !== props.previewAllItems || $[11] !== selectedSku) {
      t2 = (option, index) => <SKUSelectorRadio key={`${index}-${JSON.stringify(option)}`} index={index} option={option} selectedSku={selectedSku} isLoading={isLoading} previewAllItems={props.previewAllItems} builderBlock={props.builderBlock} onChange={sku_0 => setSelectedSku(sku_0)} />;
      $[8] = isLoading;
      $[9] = props.builderBlock;
      $[10] = props.previewAllItems;
      $[11] = selectedSku;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    t1 = props.options.map(t2);
    $[2] = isLoading;
    $[3] = props.builderBlock;
    $[4] = props.options;
    $[5] = props.previewAllItems;
    $[6] = selectedSku;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[13] !== selectedSku || $[14] !== t0 || $[15] !== t1) {
    t2 = <RadioGroup className="relative flex shrink-0 flex-col gap-2" value={selectedSku} onChange={t0}>{t1}</RadioGroup>;
    $[13] = selectedSku;
    $[14] = t0;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  const t3 = props.addToCartVariant ?? "primary";
  const t4 = isMobile ? "medium" : "large";
  let t5;
  if ($[17] !== selectedSku) {
    t5 = [{
      sku: selectedSku,
      quantity: 1
    }];
    $[17] = selectedSku;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== props.redirectUrl || $[20] !== t5) {
    t6 = {
      skus: t5,
      redirectUrl: props.redirectUrl
    };
    $[19] = props.redirectUrl;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const t7 = props.builderBlock?.id;
  let t8;
  if ($[22] !== props.addToCartContent || $[23] !== t7) {
    t8 = <BuilderBlocks blocks={props.addToCartContent} parentElementId={t7} dataPath="component.addToCartContent" />;
    $[22] = props.addToCartContent;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== isLoading || $[26] !== t3 || $[27] !== t4 || $[28] !== t6 || $[29] !== t8) {
    t9 = <Button className="mt-4 w-full" isLoading={isLoading} variant={t3} size={t4} actionName="addItemsToCart" addItemsToCart={t6}>{t8}</Button>;
    $[25] = isLoading;
    $[26] = t3;
    $[27] = t4;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t2 || $[32] !== t9) {
    t10 = <div data-testid="sku-selector">{t2}{t9}</div>;
    $[31] = t2;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
}